/**
 * Barre de navigation en bas de l'écran.
 * 4 onglets : Accueil, Listes, Communauté, Réglages.
 */
import { createElement } from '../utils/dom.js';
import { navigate, getCurrentRoute } from '../router.js';
import { iconHome, iconList, iconGlobe, iconSettings } from '../utils/icons.js';

const TABS = [
  { path: '/', icon: iconHome, label: 'Accueil' },
  { path: '/quick-list', icon: iconList, label: 'Listes' },
  { path: '/community', icon: iconGlobe, label: 'Communauté' },
  { path: '/account', icon: iconSettings, label: 'Réglages' },
];

/**
 * Rend la barre de navigation fixe en bas.
 * @returns {HTMLElement}
 */
export function renderBottomNav() {
  const currentPath = getCurrentRoute().path;

  const nav = createElement('nav', {
    className: 'bottom-nav',
    attrs: { 'aria-label': 'Navigation principale' },
  });

  for (const tab of TABS) {
    const isActive = tab.path === currentPath
      || (tab.path === '/account' && currentPath === '/login');

    const btn = createElement('button', {
      className: `bottom-nav__tab${isActive ? ' bottom-nav__tab--active' : ''}`,
      attrs: { type: 'button', 'aria-label': tab.label },
      children: [
        createElement('span', { className: 'bottom-nav__icon', children: [tab.icon(22)] }),
        createElement('span', { className: 'bottom-nav__label', text: tab.label }),
      ],
      events: {
        click: () => navigate(tab.path),
      },
    });

    nav.appendChild(btn);
  }

  return nav;
}
